namespace GeniuzPOS.Purchase {
    // import PoApprovalTranDtDialog = GeniuzPOS.Purchase.PoApprovalTranDtDialog;

    @Serenity.Decorators.registerClass()
    export class PoApprovalEditor extends Serenity.Extensions.GridEditorBase<PoApprovalTranRow> {
        protected getColumnsKey() { return "Purchase.PoApprovalTran"; }
        protected getDialogType() { return PoApprovalTranDtDialog; }
        protected getLocalTextPrefix() { return PoApprovalTranRow.localTextPrefix; }

        public qnNo: number;

        public myPassValue: string;

        private _appfg: boolean;



        constructor(container: JQuery) {
            super(container);

        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);



            return buttons;
        }


        






        protected createSlickGrid() {
            var grid = super.createSlickGrid();
            //--set new set of grid columns---
            //--get content width
            let ele = document.getElementsByClassName("grid-container");
            var bordermg = 60;
            var eleWidth = ele.item(0).clientWidth - bordermg * 5;
            var totalcolw = 0;

            let propItems = this.getPropertyItems();
            let items = this.getColumns();
            items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                totalcolw += pItem.width;

            });
            items.forEach((item, idx) => {
                let pItem = Q.tryFirst(propItems, x => x.name == item.sourceItem.name);
                pItem.resizable = true;
                pItem.width = (eleWidth / totalcolw) * pItem.width;


            });

            let c = this.postProcessColumns(this.propertyItemsToSlickColumns(propItems));
            grid.setColumns(c);
            grid.resizeCanvas();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            // this.view.setSummaryOptions({
            //     aggregators: [
            //         new Slick.Aggregators.Sum('Qty'),
            //         new Slick.Aggregators.Sum('BeforeDiscAmt'),
            //         new Slick.Aggregators.Sum('DiscAmt'),
            //         new Slick.Aggregators.Sum('AlocalteDiscAmt'),
            //         new Slick.Aggregators.Sum('ItemAmt'),
            //         new Slick.Aggregators.Sum('ItemVatAmt'),
            //         new Slick.Aggregators.Sum('ItemExVatAmt')
            //     ]
            // });
            return grid;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            opt.showHeaderRow = false;
            opt.headerRowHeight = 0;
            // opt.frozenColumn = 1;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

        public get appfg(): boolean { return this._appfg; }

        set appfg(value: boolean) {
            if (this._appfg != value) {
                this.refresh();
                this._appfg = false
            }
        }

        public clearDataGrid() {
            this.view.setItems([], true);
        }




    }
}

